import { render, staticRenderFns } from "./LeadGooseBillModal.vue?vue&type=template&id=0c0ad7cc&scoped=true&"
import script from "./LeadGooseBillModal.vue?vue&type=script&lang=js&"
export * from "./LeadGooseBillModal.vue?vue&type=script&lang=js&"
import style0 from "./LeadGooseBillModal.vue?vue&type=style&index=0&id=0c0ad7cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0ad7cc",
  null
  
)

export default component.exports